export const Pricify = (price?: number, disableToFixed?: boolean) => {
  if (price) {
    return price > 0
      ? `$${disableToFixed ? price : price.toFixed(2)}`
      : `-$${disableToFixed ? price : (price * -1).toFixed(2)}`;
  }
  return '-';
};
